var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCake3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 26.5414C5 22.5271 5.86038 21.6667 9.87467 21.6667H30.1253C34.1397 21.6667 35 22.5271 35 26.5414V30.1254C35 34.1397 34.1397 35.0001 30.1253 35.0001H9.87467C5.86038 35.0001 5 34.1397 5 30.1254V26.5414Z",
    stroke: "#B52525",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 21.6667V19.4267C10 15.7813 10.7813 15 14.4267 15H25.5733C29.2187 15 30 15.7813 30 19.4267V21.6667",
    stroke: "#B52525",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15 15.0001V11.6667",
    stroke: "#B52525",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15 5.83333V5",
    stroke: "#B52525",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25 15.0001V11.6667",
    stroke: "#B52525",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25 5.83333V5",
    stroke: "#B52525",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20 15.0001V11.6667",
    stroke: "#B52525",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M20 5.83333V5",
    stroke: "#B52525",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M5 26.7329C5.51543 26.6871 6.06412 26.6667 6.66667 26.6667C9.35028 26.6667 10.6497 28.3334 13.3333 28.3334C16.0169 28.3334 17.3163 26.6667 20 26.6667C22.6837 26.6667 23.983 28.3334 26.6667 28.3334C29.3503 28.3334 30.6497 26.6667 33.3333 26.6667C33.9358 26.6667 34.4845 26.6871 35 26.7329",
    stroke: "#B52525",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCake3);
export default __webpack_public_path__ + "static/media/cake3.efe15db3cc99d48d602afdaa30436dbd.svg";
export { ForwardRef as ReactComponent };